module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMjAwIiBoZWlnaHQ9IjYwMCIgdmlld0JveD0iMCAwIDYgMyI+PHBhdGggZmlsbD0iIzQzNkY0RCIgZD0iTTAgMGg2djNIMHoiLz48cGF0aCBmaWxsPSIjRkZGIiBkPSJNMCAwaDZ2MkgweiIvPjxwYXRoIGZpbGw9IiNDRDJBM0UiIGQ9Ik0wIDBoNnYxSDB6Ii8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/hun.svg
// module id = C5OG
// module chunks = 0